import { Component, Input, ElementRef } from '@angular/core';
import { fromEvent, merge } from 'rxjs';
import { filter, take, startWith, map, debounceTime } from 'rxjs/operators';

export enum TypeDrag {
  Move,
  Top,
  Bottom,
  Left,
  Right,
  TopRight,
  BottomRight,
  TopLeft,
  BottomLeft
}

@Component({
  selector: 'app-resizable-modal-component',
  templateUrl: './resizable-modal-component.component.html',
  styleUrls: ['./resizable-modal-component.component.scss']
})

export class ResizableModalComponentComponent {
  rect: any;
  incr: number[] = [0, 0, 0, 0];
  nativeElement: any;
  typeDrag: any;
  origin: any;
  onDrag: boolean = false;
  moveSubscription: any;
  modalContent: any;
  //modalContent:  HTMLElement;
  delayTimer: boolean = false;
  resizeTrigger: boolean = false;

  classNames = [
    'cell-top',
    'cell-border-top',
    'cell-border-bottom',
    'cell-border-left',
    'cell-border-right',
    'cell-top-right',
    'cell-bottom-right',
    'cell-top-left',
    'cell-bottom-left'
  ];

  style: any = null;
  constructor(private elementRef: ElementRef) { }

  @Input() set dragHolder(value: any) {
    value.classList.add('cell-top');
  }

  ngAfterViewInit(): void {
    this.modalContent = this.findModalContent(this.elementRef.nativeElement);
    merge(
      fromEvent(this.elementRef.nativeElement, 'mousedown'),
      fromEvent(this.elementRef.nativeElement, 'touchstart').pipe(map((event: any) => ({
        target: event.target,
        screenX: event.touches[0].screenX,
        screenY: event.touches[0].screenY
      }))
      ))
      .pipe(
        filter((event: any) => {
          const classs = (event.target as any).className;
          if (classs && typeof classs === 'string') {
            const className = classs.split(' ');
            return className.indexOf('cell-top') >= 0
              ? true
              : this.classNames.indexOf(classs) >= 0;
          }
          return false;
        })
      )
      .subscribe((event: MouseEvent) => {
        this.rect = this.modalContent.getBoundingClientRect();
        this.origin = { x: event.screenX, y: event.screenY };
        this.onDrag = true;
        const className = (event.target as any).className.split(' ');
        this.typeDrag =
          className.indexOf('cell-top') >= 0
            ? TypeDrag.Move
            : (this.classNames.indexOf(className[0]) as TypeDrag);

        this.incr =
          this.typeDrag == TypeDrag.Move
            ? [1, 0, 1, 0]
            : this.typeDrag == TypeDrag.Top
              ? [1, -1, 0, 0]
              : this.typeDrag == TypeDrag.Bottom
                ? [0, 1, 0, 0]
                : this.typeDrag == TypeDrag.Right
                  ? [0, 0, 0, 1]
                  : this.typeDrag == TypeDrag.Left
                    ? [0, 0, 1, -1]
                    : this.typeDrag == TypeDrag.TopRight
                      ? [1, -1, 0, 1]
                      : this.typeDrag == TypeDrag.TopLeft
                        ? [1, -1, 1, -1]
                        : this.typeDrag == TypeDrag.BottomRight
                          ? [0, 1, 0, 1]
                          : [0, 1, 1, -1];

        merge(fromEvent(document, 'mouseup'),
          fromEvent(document, 'touchend')
        )
          .pipe(take(1))
          .subscribe(() => {
            if (this.moveSubscription) {
              this.moveSubscription.unsubscribe();
              this.moveSubscription = undefined;
              this.onDrag = false;
            }
          });
        if (!this.moveSubscription) {
          this.moveSubscription = merge(
            fromEvent(document, 'mousemove'),
            fromEvent(document, 'touchmove').pipe(map((event: any) => ({
              target: event.target,
              screenX: event.touches[0].screenX,
              screenY: event.touches[0].screenY
            }))
            ))
            .pipe(startWith({ screenY: this.origin.y, screenX: this.origin.x }))
            .subscribe((moveEvent: any) => {
              const incrTop = moveEvent.screenY - this.origin.y;
              const incrLeft = moveEvent.screenX - this.origin.x;
              const width = this.rect.width + this.incr[3] * incrLeft;
              const heigth = this.rect.height + this.incr[1] * incrTop;
              this.modalContent.style['max-width'] =
                (width < 100 ? 100 : width) + 'vw';
              this.style = {
                width: (width < 50 ? 50 : width - 1) + 'px',
                height: (heigth < 75 ? 75 : heigth - 1) + 'px',
        
              };
            });
        }
      });
  }

  findModalContent(element: HTMLElement): any {
    return element.className == 'modal-dialog modal-dialog-scrollable modal-md'
      ? element
      : element.parentElement
        ? this.findModalContent(element.parentElement)
        : null;
  }
}

